import React,{useState} from 'react';
import "./styles.css";
import { Typography, Grid } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordianlist, jobStatusList } from "./Accordianlist"
import Details from './Details'
import ProfileTab from './ProfileTab'
import SubHeader from '../../components/Subheader/Subheader'

const ServiceRequests = () => {
  const [executed, setExecuted] = useState(3);
  const [expanded, setExpanded] = React.useState()
  

  const handleSetActive=(status) =>{
    if(status){
      setExecuted(4)
    }
   }
   const handleChange = (panel,item) =>

   (_, isExpanded) => {setExpanded(isExpanded ? panel : false)}
  return (
    <div style={{ marginTop: '1rem', width: '100%' }} className="JobList-accordionPg">
       <SubHeader name="Service Requests" options={jobStatusList}/>
      <Grid>
        {Accordianlist?.map((item, JobList) => {
          return (
            <Accordion
            key={JobList}
            onChange={handleChange(JobList)}
            expanded={expanded === JobList}
              sx={{
                backgroundColor: "#EAEAEA",
                marginBottom: "4px",
                boxShadow: "none",
                borderRadius: "5px",
                border: "none",
              }}
            >
              <AccordionSummary
                expandIcon={
                  <ExpandMoreIcon sx={{ color: "#0D5C75", fontSize: "32px" }} />
                }
                aria-controls="panel1a-content"

              >
                <Grid pl={1}>
                  <Typography
                    style={{
                      fontSize: "15px",
                      fontWeight: "600",
                      letterSpacing: "0.09px",
                      color: "#1F1F1F",
                    }}
                  >
                    Job ID : # JD {item.jobId}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                      letterSpacing: "0.09px",
                      color: "#1F1F1F",
                    }}
                  >
                    Created On: {item.createdOn}
                  </Typography>
                </Grid>
              </AccordionSummary>

              <AccordionDetails style={{ padding: '0px', backgroundColor: '#ffffff' }}>

                <Details item={item} executed={executed}/>
                <ProfileTab handleSetActive={handleSetActive}/>

              </AccordionDetails>
            </Accordion>
          );
        })}
      </Grid>
    </div>
  );;
};

export default ServiceRequests;